import { MTag } from './Monetize';

interface PastDueBadgeProps {
  pastDueInvoiceCount?: number | null;
  pastDueAmount?: number | null;
}

export const PastDueBadge = ({
  pastDueInvoiceCount,
  pastDueAmount,
}: PastDueBadgeProps) => {
  const count = pastDueInvoiceCount ?? 0;
  const amount = pastDueAmount ?? 0;

  if (count <= 0 && amount <= 0) {
    return null;
  }

  return (
    <MTag ml=".5rem" variant="red">
      Past Due
    </MTag>
  );
};
